import UnitService from 'src/services/unitService';

const state = {
  units: undefined,
  unitTypes: undefined,
};

const getters = {
  getUnits: (state) => state.units,
  getUnitTypes: (state) => state.unitTypes,
};
const actions = {
  async fetchUnits({ commit, state, rootGetters }) {
    // Only fetches reservation units.
    // Only load the data once
    if (state.units == undefined) {
      // Works up to 1000 units. We need search and paging after that anyway
      return UnitService.fetchResUnitList()
      .then(r => {
        commit('setUnits', r.data);
      });
    }
  },
  unloadUnits({ commit }) {
    commit('setUnits', undefined);
  },
  async fetchUnitTypes({ commit, state }) {
    // Only fetches reservation unitTypes.
    // Only load the data once
    if (state.unitTypes == undefined) {
      // Works up to 1000 units. We need search and paging after that anyway
      return UnitService.fetchResUnitTypeList()
      .then(r => {
        commit('setUnitTypes', r.data);
      });
    }
  },
  unloadUnitTypes({ commit }) {
    commit('setUnitTypes', undefined);
  }
};
const mutations = {
  setUnits(state, units) {
    state.units = units;
  },
  setUnitTypes(state, unitTypes) {
    state.unitTypes = unitTypes;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
